import { Component, HostListener, OnInit} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'jcwebapp';


  public test:string = 'sticky';
  isSticky: boolean = false;
  public disabled_bool:boolean = true;
  public var_online = '';
  public time_clr = '';
  @HostListener('window:scroll', ['$event'])

  checkScroll() {
    this.isSticky = window.pageYOffset >= 100;
  }

  constructor(private router: Router){}


  ngOnInit(){

    const d = new Date();
    var month = d.getMonth() + 1;

    //alert(d.getDate() + "/" + month + "/" + d.getFullYear())
    //17 == 6PM

    if(d.getHours()>=10 && d.getHours()<=16 && !(d.getDay()==7)){
      this.var_online= "I'm Online";
      this.disabled_bool = false;
      return;
    }
    else{
      this.time_clr = 'yellow'
      this.var_online= "I'm Offline";
      this.disabled_bool = true;
      return;
    }


    // alert(new Date())
  //   this.router.events.subscribe((evt) => {
  //     if (!(evt instanceof NavigationEnd)) {
  //         return;
  //     }
  //     window.scrollTo(0, 0)
  // });
  }

  conditionOther = false;
  menu_cls = 'hide_cls';
  otherStyles = {};

  public toggleOther() {
    this.conditionOther = !this.conditionOther;
    if (this.conditionOther) {
      this.menu_cls = 'show_cls';
      // this.otherStyles = {

      //   'display' : 'block'
      // };
    } else {
      this.menu_cls = 'hide_cls';
      // this.otherStyles = {
      //   'display' : 'none'
      // };
    }
  }

  tests(){
    this.conditionOther = !this.conditionOther;
    if (this.conditionOther) {
      this.menu_cls = 'show_cls';
      // this.otherStyles = {

      //   'display' : 'block'
      // };
    } else {
      this.menu_cls = 'hide_cls';
      // this.otherStyles = {
      //   'display' : 'none'
      // };
    }
  }
  tested(){
    window.open('https://api.whatsapp.com/send?phone=919941906196&text=Hello%2C+Admin', "_blank")
  }

  tested2(){
    window.open('https://api.whatsapp.com/send?phone=919444919744&text=Hello%2C+NIMI HelpDesk', "_blank")
  }

  whatsapp_bool:boolean = false;
  need_bool:boolean = true
  show_main(){
    this.need_bool = false;
  this.whatsapp_bool = true;
  }
  show_need(){
    this.need_bool = true;
    this.whatsapp_bool = false;
  }

}
